import { Path } from '@/main/router/routerPath';

import { ModelNv } from './modelNv';
import { ZarazeniPnv } from './zarazeniPnv';

export const router = new Path('Novevozy').addChildren([
	ModelNv.router,
	ZarazeniPnv.router,
]);
